export const ACTION = {
  RESET_STATE: 'RESET_STATE',
  CHANGE_NOTIFICATION_READ_STATUS: 'CHANGE_NOTIFICATION_READ_STATUS',
  SET_NOTIFICATION_LIST: 'SET_NOTIFICATION_LIST',
  // LOGOUT: 'LOGOUT',
};